import axios from 'axios'
import { API } from 'constants/apiEndPoints'
import { useEffect, useState } from 'react'

const INIT_COUNTRY_ALLOWANCE = {
  isIpCheckReady: false,
  isAllowed: false,
  countryISOCode: '',
  timeOffsetMs: 0,
}

export const checkIpAllowance = async (): Promise<typeof INIT_COUNTRY_ALLOWANCE> => {
  const { data } = await axios.post(API.AUTH_IP_CHECK)
  const payload = {
    isIpCheckReady: true,
    isAllowed: data?.allowed,
    countryISOCode: data?.countryISOCode,
    timeOffsetMs: 0,
  }
  return payload
}

export const useIpCheck = () => {
  const [ipAllowance, setIpAllowance] = useState(INIT_COUNTRY_ALLOWANCE)

  const updateCountryAllowance = async () =>{
    await checkIpAllowance().then((payload) => {
      setIpAllowance(payload)
    })
  }

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    updateCountryAllowance()
  }, [])

  return ipAllowance
}

